import { render, staticRenderFns } from "./GLink.vue?vue&type=template&id=0f5e4699&"
import script from "./GLink.vue?vue&type=script&lang=ts&"
export * from "./GLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports